import { render, staticRenderFns } from "./ui-chevron.vue?vue&type=template&id=aed29dea&"
import script from "./ui-chevron.vue?vue&type=script&lang=ts&"
export * from "./ui-chevron.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports